import { render } from "./SidebarItem.vue?vue&type=template&id=61fadc8f&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=61fadc8f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fadc8f"],['__file',"src/components/SidebarPlugin/SidebarItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61fadc8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61fadc8f', __exports__)) {
    api.reload('61fadc8f', __exports__)
  }
  
  module.hot.accept("./SidebarItem.vue?vue&type=template&id=61fadc8f&scoped=true", () => {
    api.rerender('61fadc8f', render)
  })

}


export default __exports__